import React from 'react'
import './menjin.less';
import { Carousel } from 'antd';
import Common from './../../api/common.jsx'
import Bottom from './../../api/bottom.jsx'
import icon_mj_fen from './../../imgs/icon_mj_fen.svg';
import icon_mj_setting from './../../imgs/icon_mj_setting.svg';
import icon_mj_tie from './../../imgs/icon_mj_tie.svg';
import icon_mj_up from './../../imgs/icon_mj_up.svg';
import icon_mj_xunhuan from './../../imgs/icon_mj_xunhuan.svg';
import img_mj_four from './../../imgs/img_mj_four.png';
import img_mj_one from './../../imgs/img_mj_one.png';
import img_mj_two from './../../imgs/img_mj_two.png';
import img_mj_three from '../../imgs/img_mj_three.png';
import img_mj_tfive from '../../imgs/img_mj_tfive.png';
import product_banner_advertisement1 from './../../imgs/product_banner_advertisement1.jpg'
export default class menjin extends React.Component {
    render() {
        return (<div className='menjin'>
            <Common history={this.props.history}></Common>
            <div className="ttop">
                <img style={{width:'100%',height:700}} src={product_banner_advertisement1} alt=""/>
            </div>
            <div class="img_list">
                <ul>
                    <li><img src={img_mj_one} alt="" /></li>
                    <li><img src={img_mj_two} alt="" /></li>
                    <li><img src={img_mj_three} alt="g" /></li>
                    <li style={{ marginTop: 700 }}><img src={img_mj_tfive} alt="" /></li>
                </ul>
            </div>
            <div className="medium">
                <span>智慧门禁优点你知多少?</span>
                <ul className="medium_text">
                    <li>
                        <p>建设成本低：一门一机，线路非常简单，改造成本低</p>
                        <div className="door_box1">
                            <span>智能门禁优点：</span>
                            <ol>
                                <li>
                                    <p>系统精简，低碳环保</p>
                                </li>
                                <li>
                                    <p>门禁对讲系统占小区智能化系统建设成本的60%，E门禁系统采用</p>
                                </li>
                                <li>
                                    <p>/有线专王通讯方式，用智能手机替代传统门禁对讲系统的室内分</p>
                                </li>
                                <li>
                                    <p>省施工、省维护，综合成本降低70%-80%。</p>
                                </li>
                            </ol>

                            <span>传统门禁缺点：</span>
                            <ol>
                                <li>
                                    <p>设备众多，工程量大，管线成本，设备成本；</p>
                                </li>
                                <li>
                                    <p>采用有线链接，布线多，产生的用户终端与中间设备多，</p>
                                </li>
                                <li>
                                    <p>且工程量大，牵扯事项多，施工复杂</p>
                                </li>
                            </ol>
                        </div>
                    </li>
                    <li>
                        <p style={{ marginTop: 154 }}>安装和维护便捷</p>
                        <div className="door_box1">
                            <span style={{ marginBottom: 17 }}>即装即用</span>
                            <ol>
                                <li><img src={icon_mj_fen} alt="" /></li>
                                <li><img src={icon_mj_setting} alt="" /></li>
                                <li><img src={icon_mj_tie} alt="" /></li>
                                <li><img src={icon_mj_up} alt="" /></li>
                                <li><img src={icon_mj_xunhuan} alt="" /></li>
                            </ol>
                        </div>
                    </li>
                    <li>
                        <p className="medium_text1">人脸识别、APP开门方便快捷安全</p>
                        <div className="door_box1">
                            <div className="door_box2">
                                <ol>
                                    <li>人脸识别：</li>
                                    <p>用户体验佳，远程自动识别，快速扫码，无感进入，不用带门禁卡，极速体验；</p>
                                    <p>管理便捷，短长期来访，租户分类管理，出入信息管理。</p>
                                    <br />
                                    <p>用户仅在彩之云APP上传人脸照片后，在有人脸识别开门功能的主机1-2米处，</p>
                                    <p>主机即可扫描比对开门，此功能限有人脸识别功能的主机型号。</p>
                                    <li>彩之云APP一键开门：</li>
                                    <p>业主在彩之云APP的开门按钮处点击对应按钮即可打开对应门锁，主机有图片和声音提醒门锁已打开；</p>
                                    <p>同时业主手机应处于数据联网状态。</p>
                                    <li>呼叫业主手机对讲开门：</li>
                                    <p>访客在主机案件上输入业主手机号码（前提条件：业主手机号码已经录入RMS，且已注册彩之云APP，</p>
                                    <p>只能接电话的老年机等，可由业主家人用其智能手机帮忙注册彩之云APP），业主手机来电，</p>
                                    <p>接听电话后与访客通话，确认访客身份后，在手机键盘按『#』即可为访客打开门锁，请访客进入。</p>
                                    <li>刷卡开门：</li>
                                    <p>接听电话后与访客通话，确认访客身份后，在手机键盘按『#』即可为访客打开门锁，请访客进入。</p>
                                </ol>
                            </div>
                        </div>
                    </li>
                    <li>
                        <p className="medium_text2" style={{ marginTop: 150, marginBottom: 27 }}>智慧门禁的运营价值</p>
                        <div className="door_box1">
                            <div className="door_box3">
                                <ol>
                                    <li>用户信息收集：</li>
                                    <li>APP快速增长</li>
                                    <li>打通物业缴费</li>
                                    <li>推广彩惠人生</li>
                                </ol>
                            </div>
                        </div>
                    </li>
                    <img src={img_mj_four} alt="" style={{ marginLeft: 229, marginTop: 67 }} />
                </ul>
                <div className="door_box3">
                    <span>社区运营商业营销闭环</span>
                    <div className="door_box4">
                        <ul>
                            <li>
                                <p>数据反馈：</p>
                                <p>传播监控、数据分析</p>
                            </li>
                            <li>
                                <p>广告展示：</p>
                                <p>品牌推广、信息传播</p>
                            </li>
                            <li>
                                <p>体验消费：</p>
                                <p>体验营销、支付消费</p>
                            </li>
                        </ul>

                    </div>
                    <div className="door_box5">
                        <ul>
                            <li>
                                <p>体验消费：</p>
                                <p>体验营销、支付消费</p>
                            </li>
                            <li>
                                <p>开门互动：</p>
                                <p>开门互动、用户体验</p>
                            </li>

                        </ul>
                    </div>

                </div>

            </div>
            <div style={{position:"fixed",bottom:0,left:0,width:'100%'}}>
            <Bottom ></Bottom>
            </div>
            
        </div>)
    }
}


// WEBPACK FOOTER //
// ./src/pages/menjin/menjin.jsx